// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_screen__Qhl7X > div > div:last-child {
  max-width: 0rem; }

.styles_screen__Qhl7X > div > div:nth-child(2) {
  width: -webkit-fill-available;
  min-width: 72vw;
  right: 5vw;
  position: absolute;
  padding: 1rem;
  height: -webkit-fill-available; }

.styles_introspectionCard__nQW23 {
  height: 50vh; }
`, "",{"version":3,"sources":["webpack://./src/modules/teachings/components/screens/TeachingsBoothScreen/styles.module.scss"],"names":[],"mappings":"AAAA;EAEQ,eAAe,EAAA;;AAFvB;EAKQ,6BAA6B;EAC7B,eAAe;EACf,UAAU;EACV,kBAAkB;EAClB,aAAa;EACb,8BAA8B,EAAA;;AAItC;EACI,YAAY,EAAA","sourcesContent":[".screen {\n    & > div > div:last-child {\n        max-width: 0rem;\n    }\n    & > div > div:nth-child(2) {\n        width: -webkit-fill-available;\n        min-width: 72vw;\n        right: 5vw;\n        position: absolute;\n        padding: 1rem;\n        height: -webkit-fill-available;\n    }\n}\n\n.introspectionCard {\n    height: 50vh;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"screen": `styles_screen__Qhl7X`,
	"introspectionCard": `styles_introspectionCard__nQW23`
};
export default ___CSS_LOADER_EXPORT___;
